import { Flex } from '@mantine/core';
import type { ReactNode } from 'react';

interface EventsPanelProps {
  children: ReactNode;
  radius?: number | string;
}

/**
 * EventsPanel — базовый контейнер для блока истории событий.
 * Держит единый layout (колонка, отступы, высота).
 */
export function EventsPanel({ children, radius = 8 }: EventsPanelProps) {
  return (
    <Flex
      className='bg-gradient-pattern-chat'
      direction='column'
      h='100%'
      mih={0}
      w='100%'
      style={{ borderRadius: radius }}
    >
      {children}
    </Flex>
  );
}
